// extracted by mini-css-extract-plugin
export default {"purchaseSolarComponent":"purchase-solar-component_purchaseSolarComponent__4s4Qz"};